import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {SeatClassRequest} from 'app/types/service-types/AircraftTypes';
import {SeatClassService} from 'app/services';
import {fetchAllSeatClasses} from './seat-classes.slice';
import {errorMsg, successMsg} from 'app/utils/MessageUtils';

interface UpdateSeatClassParams {
  id: string;
  body: SeatClassRequest;
  onSuccess?: Function;
  onError?: Function;
}

export const updateSeatClass = (params: UpdateSeatClassParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await SeatClassService.update(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg('Seat class updated successfully!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllSeatClasses());
    }
    dispatch(setLoading(false));
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err?.data?.message));
    if (params.onError) params.onError();
    dispatch(setError(err?.data?.message));
  }
}

interface UpdateSeatClassSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateSeatClassSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'aircrafts/update-seat-class',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSuccess: (state, action) => { state.success = action.payload },
    setError: (state, action) => { state.error = action.payload }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;
export default stateSlice.reducer;
